// Utils
import { component } from 'picoapp';

import choozy from 'utils/choozy';

export default component((node) => {
  const { mergerForm, inner, productForm = [] } = choozy(node);

  const productForms = [].concat(productForm);

  const formEntries = node.dataset.formEntries.split(',');

  let formSubmissions = {};
  let formSubmitter = null;
  let items = [];

  inner.addEventListener('product:form:submit', (e) => {
    e.stopPropagation();

    const { formId, form, product, variant } = e.detail;

    formSubmissions[formId] = form;

    items.push({
      product,
      variant,
      quantity: 1,
    });

    // If all the child forms have been submitted correctly, add them together
    const isSuitSelectorForm =
      form.hasAttribute('data-placement') &&
      form.getAttribute('data-placement') === 'suit_selector_form';

    if (formEntries.every((id) => id in formSubmissions) || isSuitSelectorForm) {
      const formData = new FormData();

      formEntries.forEach((id) => {
        const submittedFormData = new FormData(formSubmissions[id]);
        const variantId = submittedFormData.get('id');

        formData.append('items[][id]', isSuitSelectorForm ? variant.id : variantId);
      });

      const customSubmitEvent = new CustomEvent('product:form:submit', {
        bubbles: true,
        cancelable: true,
        detail: {
          formId: mergerForm.dataset.formId,
          form: mergerForm,
          formData,
          items,
          skipCartDrawer: node.dataset.skipCartDrawer === 'true',
        },
      });

      node.dispatchEvent(customSubmitEvent);

      return;
    }

    const nextFormId = formEntries.find((id) => !(id in formSubmissions));
    const nextForm = productForms.find((_form) => _form.dataset.formId === nextFormId);

    if (nextForm) {
      const submitEvent = new SubmitEvent('submit', {
        cancelable: true,
        bubbles: true,
        submitter: formSubmitter,
      });

      nextForm.dispatchEvent(submitEvent);
    }
  });

  mergerForm.addEventListener('submit', (e) => {
    e.preventDefault();
    e.stopPropagation();

    formSubmitter = e.submitter;
    formSubmissions = {};
    items = [];

    // return;
    const submitEvent = new SubmitEvent('submit', {
      cancelable: true,
      bubbles: true,
      submitter: formSubmitter,
    });

    productForms[0].dispatchEvent(submitEvent);
  });
});
